import { CSSProperties, useEffect, useState } from 'react';
import classes from './NotifyMe.module.css'
import { NotificationOutlineIcon } from '@/components/Icons';
import Button from '@/components/buttons/Button';
import { Input } from '@mantine/core';
import { toastMe } from '@/utils';
import { useAppSelector } from '@/store/hooks';

interface Props {
    className?: string;
    style?: CSSProperties;

    onClose?: () => void;
    onSubmit?: (data: {
        phone?: string;
        email?: string;
    }) => void;
}

const NotifyMe = ({
    className,
    style,

    onClose,
    onSubmit,
}: Props) => {
    const user = useAppSelector(state => state.auth.user);

    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('')

    useEffect(() => {
        if (user?.phone) {
            setPhone(user.phone);
        }

        if (user?.email) {
            setEmail(user.email);
        }
    }, [user?.phone, user?.email])

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const phoneNumber = phone ? "0" + phone.trim()?.slice(-10) : '';

        if (onSubmit) {
            onSubmit({
                phone: phoneNumber,
                email,
            });
        }
    }

    const phoneIsValid = phone.length >= 11 && phone.length <= 14;

    const desabled = !phoneIsValid && !email;

    const classNames = [classes.NotifyMe, className];
    
    return (
        <div className={classNames.join(' ')} style={style}>

            <form className={classes.form} onSubmit={handleSubmit}>
                <div className={classes.top}>
                    <NotificationOutlineIcon width={36} height={36} className={classes.icon} />
                </div>

                <div className={classes.formGroup}>
                    <label className={classes.label}>Phone Number</label>
                    <Input
                        placeholder="Enter your phone number"
                        prefix='+880'
                        type="tel"
                        required={false}

                        value={phone}
                        onChange={event => setPhone(event.currentTarget.value)}

                        classNames={{
                            input: classes.input,
                            section: classes.section,
                        }}
                    />
                </div>

                <div className={classes.formGroup}>
                    <label className={classes.label}>Email</label>
                    <Input
                        placeholder="Enter your email"
                        type="email"
                        required={false}

                        value={email}
                        onChange={event => setEmail(event.currentTarget.value)}

                        classNames={{
                            input: classes.input,
                            section: classes.section,
                        }}
                    />
                </div>

                <Button className={classes.button}
                    btnType={!desabled ? 'primary' : 'outline'}
                    type='submit'
                    disabled={desabled}
                >
                    Notify Me
                </Button>
            </form>

        </div>
    )
}

export default NotifyMe